export default "__VITE_ASSET__Bd7cz3wM__"